export default __webpack_public_path__ + "static/bottom-571761884ea372ceb3d2b55bae1ef8b9.png";